import { render } from "./CustomerGoCardlessPaymentTokens.vue?vue&type=template&id=19aaef9d"
import script from "./CustomerGoCardlessPaymentTokens.vue?vue&type=script&lang=js"
export * from "./CustomerGoCardlessPaymentTokens.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__